import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { AppError } from "@obg/ngx.core";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import {
	REGISTRATION_WITH_BANK_ID_ACTION_TYPE,
	RegistrationWithBankIdAction,
} from "./registration-with-bank-id.action";
import { RegistrationWithBankIdService } from "./registration-with-bank-id.service";

@Injectable()
export class RegistrationWithBankIdEffect {
	getBankIdRegistrationUrl$ = createEffect(() =>
		this.actions$.pipe(
			ofType(REGISTRATION_WITH_BANK_ID_ACTION_TYPE.getBankIdRegistrationUrl),
			switchMap(() =>
				this.registrationWithBankIdService.getBankIdRegistrationUrl().pipe(
					map(
						(response) => {
							const registrationUrl = this.registrationWithBankIdService.addReturnUrl(
								response.endpointUri
							);
							return this.action.getBankIdRegistrationUrlSuccess(registrationUrl);
						},
						catchError((response: AppError) => of(this.action.getBankIdRegistrationUrlFail(response)))
					)
				)
			)
		)
	);

	constructor(
		private actions$: Actions,
		private action: RegistrationWithBankIdAction,
		private registrationWithBankIdService: RegistrationWithBankIdService
	) {}
}
